import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslatePipe } from '../../pipes/translate.pipe';

export type ConfirmDialogResponse = boolean;

interface OptionalParams {
	yesLabel?: string;
	noLabel?: string;
	title?: string;
	translate?: boolean | {
		message?: boolean;
		yesLabel?: boolean;
		noLabel?: boolean;
		title?: boolean;
	};
	yesColor?: ThemePalette;
	noColor?: ThemePalette;
}
export interface ReorderDialogParams extends OptionalParams {
	message: string | string[];
}
export interface DialogData {
  animal: string;
  name: string;
  saveAsNew: boolean;
  repeat: boolean;
  repeatUnit: string;
  repeatCount: number;
  repeatMax: number;
  repeatOrNew: string;
}
@Component({
	selector: 'app-confirm-dialog',
	templateUrl: './confirm-dialog.component.html',
	styleUrls: ['./confirm-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReorderDialogComponent  {
	favoriteSeason: string;
 	schedule: string[] = ['Week', "Month"];
 	repeatOrNew: string[] = ['Save as new', 'Repeat']
	constructor(
    public dialogRef: MatDialogRef<ReorderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

}
